import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import ShortLinkDropdown from '../../../components/DropDown/ShortLinkDropdown';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const CreateBusinessCardLinkModal = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [customBackResp, setCustomBackResp] = useState(null);

    const handleClose = () => {
        setCustomBackResp(null);
        setShow(false)
    };
    const handleShow = () => {
        setShow(true);
    };

    const submit = async () => {
        if (document.getElementById('linkCode').value?.trim()) {
            loadingShow();
            let postData = {
                linkCode: document.getElementById('linkCode').value?.trim(),
            }
            if (document.getElementById("name").value?.trim()) {
                postData.name = document.getElementById("name").value?.trim();
            }
            let resp = await postApi(postData, urlApi.createBusinessCardLink);
            loadingHide();
            if (resp.responseCode === 200) {
                navigate('/create-business-cards/' + resp?.data);
                handleClose();
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error('Please enter a name');
        }
    }

    const checkCustomBackHalf = async (e) => {
        let postData = {
            "linkCode": e.target.value?.trim(),
        }
        if (e.target.value?.length >= 3) {
            let resp = await postApi(postData, urlApi.checkCustomBackHalf);
            setCustomBackResp(resp);
        } else if (e.target.value?.length == 0) {
            setCustomBackResp(null);
        }
    }

    return (
        <>
            <button className='primary-btn' onClick={handleShow}>Create Card</button>
            <Modal show={show} onHide={handleClose} size='lg' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Create Digital Business Card</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <p className="text-sm text-center text-[var(--secondary-text)] !mb-3">Build a beautiful digital business card to share and manage all the business details that matter to your business. <br /> Attriva powers hundreds of thousands of business cards for creators and businesses of all kinds. </p>

                    <div className='mb-4'>
                        <label htmlFor="" className='text-sm font-semibold mb-1'>Title (Optional)</label>
                        <input type='text' id='name' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter Business Card title...' />
                    </div>

                    <p className="text-[15px] font-semibold mb-1">Claim your URL</p>
                    <div className="flex flex-wrap md:flex-nowrap">
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <ShortLinkDropdown isTitle={false} />
                        </div>
                        <div className='mb-3 w-full md:w-[50%] px-2'>
                            <input type='text' id='linkCode' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Your name / Business (Minimum 3 Character)' onChange={_debounce((e) => checkCustomBackHalf(e), 300)} />
                            <p className="mb-0 text-xs text-gray-500">
                                *Minimum 3 characters, including alphanumeric and special (only ' - ' , ' _ ') characters.
                            </p>
                            {
                                customBackResp &&
                                <div className={`text-xs ps-1 ${customBackResp?.responseCode == 200 ? "text-green-700" : 'text-red-700'}`}>{customBackResp?.message}</div>
                            }
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-between gap-3'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateBusinessCardLinkModal